import { useEffect } from "react";
import { Action } from "redux-saga";
import { message } from "antd";
import { useDispatch } from "react-redux";

import { usePost } from "../../../store/post";
import { getMessageInError } from "../../../hooks/fetch";
import {
    postList,
    postListClear,
    postListErrorClear,
    PostListParams,
} from "../../../store/post/list";

export const usePostList = () => {
    const dispatch = useDispatch();
    const { list } = usePost();

    const getPosts = (params: PostListParams) => {
        dispatch(postList(params) as Action)
    }

    useEffect(() => () => {
        dispatch(postListClear() as Action)
        dispatch(postListErrorClear() as Action)
    }, [])

    useEffect(() => {
        if (list.error) {
            message
                .error(getMessageInError(list.error))
                .then(() => dispatch(postListErrorClear() as Action));
        }
    }, [list.error])

    return { getPosts, response: list.response, error: list.error, loading: list.loading, };
}
